import { render, staticRenderFns } from "./JianduMemberList.vue?vue&type=template&id=4567b4bc&scoped=true&"
import script from "./JianduMemberList.vue?vue&type=script&lang=js&"
export * from "./JianduMemberList.vue?vue&type=script&lang=js&"
import style0 from "./JianduMemberList.vue?vue&type=style&index=0&id=4567b4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4567b4bc",
  null
  
)

export default component.exports